import { h } from 'preact'
import { Author } from './index.sync'
import UserAvatar from '../User/UserAvatar'
import TopicReplyCount from '../../control-components/ui-components/TopicReplyCount'
import ClampLines from 'react-clamp-lines'
import htmlParser from '../utils/htmlParser'
import LazyLoader from '../lazy-loading/LazyLoader'
import { common } from '../common'
import TopicViewsCount from '../../control-components/ui-components/TopicViewsCount'
import { ProductAreaType } from '../../control-components/product-areas/ProductAreaSelect'

interface Props {
  content: string
  featuredImage: string
  id: number
  title: string
  url: string
  fullWidth: boolean
  index: number
  customClass: string
  label: string
  replyCount: number
  views: number
  createdAt: string
  author: Author
  allProductAreas: ProductAreaType[]
  assignedProductAreas: string[]
}

const FeaturedProductUpdateView = (props: Props) => {
  const { label = '', replyCount, views, title, url, author, featuredImage, content, fullWidth, customClass = '', createdAt, assignedProductAreas } = props
  const createTime = new Date(createdAt).getTime()
  const productAreaMapping: {
    [key: string]: string
  } = {}
  props.allProductAreas.forEach(productArea => {
    productAreaMapping[productArea.id] = productArea.name
  })

  return (
    <article className={`featured-topic ${fullWidth ? 'featured-topic--full-width' : ''} ${featuredImage && 'featured-topic--featured-image'} ${customClass}`}>
      <a href={url} className='featured-topic__url-link' />
      <div className='featured-topic__url card-widget-wrapper'>
        <div>
          {
            label && (
              <span className='topic__content-type-pill pill pill--uppercase pill--article qa-content-type-pill'>
                {label}
              </span>
            )
          }
          {
            featuredImage && <LazyLoader type='background' src={featuredImage} classNames='featured-topic__hero' />
          }
        </div>
        <div className='featured-topic__title'>
          <h3
            className={`featured-topic__heading card-widget-title ${!featuredImage && label ? 'featured-topic__heading--no-image' : ''}`}
          >
            {title}
          </h3>
          {
            typeof window !== 'undefined' && window.inSidedData?.device !== 'mobile' && (fullWidth || !featuredImage) &&
              <p className='card-widget-text'>
                <ClampLines id='featured-product-update-view' lines={3} text={htmlParser.stripHtml(content) || ''} buttons={false} />
              </p>
          }
          {
            assignedProductAreas.length
              ? fullWidth
                ? (
                  <ul className='featured-topic__product-areas'>
                    {
                      assignedProductAreas.map(assignedProductArea => (
                        <li
                          key={assignedProductArea}
                          className='featured-topic__product-area'
                        >{productAreaMapping[assignedProductArea]}</li>
                      ))
                    }
                  </ul>
                  )
                : (
                  <ul className='featured-topic__product-areas'>
                    <li
                      className='featured-topic__product-area'
                    >{productAreaMapping[assignedProductAreas[0]]}</li>
                    {
                      assignedProductAreas.length > 1 && (
                        <li className='featured-topic__product-area-count' aria-label='Count of assigned product areas'>
                          {`+ ${assignedProductAreas.length - 1}`}
                        </li>
                      )
                    }
                  </ul>
                  )
              : null
          }
          <div className='post-meta__container'>
            <div className='post-meta__container--left'>
              <UserAvatar user={author} extraClass='avatar avatar--XS' />
              <span className='thread-meta-item__date'>
                {common.relativeDate(createTime)}
              </span>
            </div>
            <div className='post-meta__container--right'>
              <TopicViewsCount views={views} />
              <TopicReplyCount replyCount={replyCount} />
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}

export default FeaturedProductUpdateView
